import { render, staticRenderFns } from "./dialog-hot-school.vue?vue&type=template&id=541c0709"
import script from "./dialog-hot-school.vue?vue&type=script&lang=js"
export * from "./dialog-hot-school.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports